import { Label } from '@dynamika-shared/ui/Label/Label';

type VisitTabLabelProps = {
  title: string;
  count?: number;
};

export const VisitTabLabel = ({ title, count = 0 }: VisitTabLabelProps) => {
  return (
    <div className="flex items-center">
      <span className="text-1624 font-medium">{title}</span>

      {!!count && (
        <Label className="!leading-8 ms-1">
          {count}
        </Label>
      )}
    </div>
  );
};
